module.exports = __webpack_public_path__ + "img/paidcoupon.da18f67b.png";